<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » 予約状況詳細（編集）の説明
  </div>

  <mat-card appearance="outlined" class="manual-card">
    <mat-card-header>
      <mat-card-title><span>予約状況詳細（編集）の説明</span></mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <div class="manual-img">
        <img src="assets/img/manual/reservation-dialog.png" width="100%">
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/A.png"> 閉じるボタン
      </div>
      <div class="manual-explain">
        クリックすることでダイアログを閉じます。<br>
        その際、編集した内容は保存されません。
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/B.png"> 予約番号、施設ID、予約施設名、属性、利用日、利用時間、登録日時、更新日時、キャンセル日時、キャンセル実行者、メール送信状況
      </div>
      <div class="manual-explain">
        予約情報を表示します。読み取り専用で変更はできません。<br>
        ※キャンセル日時とキャンセル実行者は、キャンセルされた時に表示されます。
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/C.png"> 予約状況
      </div>
      <div class="manual-explain">
        予約状況を選択することができます。<br>
        「取消」を選択し更新すると、キャンセル日時、キャンセル実行者（赤枠B）を表示します。<br>
        「取消」実行後は選択すること（更新）はできません。
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/D.png"> メモ
      </div>
      <div class="manual-explain">
        メモを編集することができます。
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/E.png"> 予約情報項目
      </div>
      <div class="manual-explain">
        予約情報の各項目を編集することができます。<br>
        <span class="manual-explain-notes">※メールアドレスは必須</span>
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/F.png"> 更新ボタン
      </div>
      <div class="manual-explain">
        クリックすることで編集内容が更新されます。
      </div>

    </mat-card-content>
  </mat-card>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Explanation of Reservation Status Details (Edit)
  </div>
  
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
  
    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of Reservation Status Details (Edit)</span></mat-card-title>
      </mat-card-header>
  
      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_reservation-dialog.png" width="100%">
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Close Button
        </div>
        <div class="manual-explain">
          Clicking this button will close the dialog.<br>
          Edited content will not be saved.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Reservation Number, Facility ID, Reserved Facility Name, Attribute, Usage Date, Usage Time, Registration Date, Update Date, Cancellation Date, Canceller, Email Sending Status
        </div>
        <div class="manual-explain">
          Displays reservation information. It is read-only and cannot be modified.<br>
          * Cancellation Date and Canceller will be displayed when a reservation is canceled.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Reservation Status
        </div>
        <div class="manual-explain">
          You can select the reservation status.<br>
          If "Cancel" is selected and updated, the Cancellation Date and Canceller (red box B) will be displayed.<br>
          Once "Cancel" is executed, further selection (updates) will not be possible.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Memo
        </div>
        <div class="manual-explain">
          You can edit the memo.
        </div>
        
        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> Reservation Information Fields
        </div>
        <div class="manual-explain">
          You can edit each field of the reservation information.<br>
          <span class="manual-explain-notes">* Email address is required</span>
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> Update Button
        </div>
        <div class="manual-explain">
          Clicking this button will apply the edited content.
        </div>
  
      </mat-card-content>
    </mat-card>
  
  </div>  
</div>